/*	========================================================================
	*	DOM-based	Routing
	*	Based	on	http://goo.gl/EUTi53	by	Paul	Irish
	*
	*	Only	fires	on	body	classes	that	match.	If	a	body	class	contains	a	dash,
	*	replace	the	dash	with	an	underscore	when	adding	it	to	the	object	below.
	*
	*	.noConflict()
	*	The	routing	is	enclosed	within	an	anonymous	function	so	that	you	can
	*	always	reference	jQuery	with	$,	even	when	in	.noConflict()	mode.
	*	========================================================================	*/

(function($)	{

		var	Ctrl	=	{
				//	All	pages
				'common':	{
						init:	function()	{
								//	JavaScript	to	be	fired	on	all	pages
						},
						finalize:	function()	{
						
						}
				},
				//	Home	page
				'home':	{
						init:	function()	{
								//	JavaScript	to	be	fired	on	the	home	page
						},
						finalize:	function()	{
							$(function() {
							  $('a[href*=#]:not([href=#])').click(function() {
							    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
							      var target = $(this.hash);
							      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
							      if (target.length) {
							        $('html,body').animate({
							          scrollTop: target.offset().top - 30
							        }, 1000);
							        if(windowWidth <= 1050){
								        $('#mobile-button').removeClass('open');
								        $('nav').slideUp();
							        }
							        return false;
							      }
							    }
							  });
							});
							
							setTimeout(function(){
								$('#logo').css('transition', 'all, 0.5s');
							}, 100);
							
							$('#logo').click(function(){
								$('html, body').animate({
									scrollTop: 0
								}, 1000);
							});
							
							$('#find-out').click(function(){
								$('html, body').animate({
									scrollTop: $('#what').offset().top - 20
								}, 1000);
							});
							
							var windowWidth = $(window).width();
													
							setTimeout(function(){
								var headerHeight = $('header').outerHeight();
								$('#homepage-start').css('marginTop', headerHeight + 'px');
							}, 100);
							
							$(window).resize(function(){
								headerHeight = $('header').outerHeight();
								$('#homepage-start').css('marginTop', headerHeight + 'px');
							});
							
							var logoTop = 200;
							var lastPosition = 0;
							
							var currentPosition = $(window).scrollTop();
							
							if(currentPosition >= 100){
								
								$('#logo').css('top', '0px');
							
							}
							
							else{
								toMove = 0 + (lastPosition - $(window).scrollTop());
								logoTop = logoTop + toMove; 
								
								console.log(logoTop);
								
								lastPosition = $(window).scrollTop();
								
								if(logoTop >= 0 && logoTop <= 200){
									$('#logo').css('top', logoTop + 'px');
								}
							}
							
							$(window).scroll(function(){
								
								toMove = 0 + (lastPosition - $(window).scrollTop());
								logoTop = logoTop + toMove; 
								
								console.log(logoTop);
								
								lastPosition = $(window).scrollTop();
								
								if(logoTop >= 0 && logoTop <= 200){
									$('#logo').css('top', logoTop + 'px');
								}
								
							});
							
							amountScrolled = $(window).scrollTop();
								
							if(amountScrolled > 200){
								$('#logo').addClass('fixed');
							}
							else{
								$('#logo').removeClass('fixed');
							}
						
							$(window).scroll(function(){
								
								amountScrolled = $(window).scrollTop();
								
								if(amountScrolled > 200){
									$('#logo').addClass('fixed');
								}
								else{
									$('#logo').removeClass('fixed');
								}
								
								if(windowWidth <= 1050){
									if(amountScrolled > 100){
										$('#logo').fadeIn();
									}
									else{
										$('#logo').fadeOut();
									}
								}
								
							});
							
							//Fading Slideshow Top
							//Randomise that first.
							
							var totalSlides = $('.fade-slide').length;
							var random = Math.floor(Math.random() * totalSlides) + 1;
							$('.fade-slide').first().before($(".fade-slide").eq(random));
							
							var activeCheck = 0;
							activeCheck = $('.active').length;
							console.log(activeCheck);
							
							var nextCheck = 0;
							nextCheck = $('.next').length;
							console.log(nextCheck);
							
							if(activeCheck === 0){
								$('.fade-slide').first().addClass('active').fadeIn('slow', function(){
									$('.active').next().addClass('next');
								});
							}
							else if(nextCheck === 0){
								$('.active').removeClass('active');
								$('.fade-slide').first().addClass('active').fadeIn('slow', function(){
									$('.active').next().addClass('next');
								});
							}
							else{
								$('.active').removeClass('active').fadeOut('slow', function(){
									$('.next').fadeIn('slow').removeClass('next').addClass('active').next().addClass('next');
								});
							}
							
							setInterval(function(){
							
								var activeCheck = 0;
								activeCheck = $('.active').length;
								console.log(activeCheck);
								
								var nextCheck = 0;
								nextCheck = $('.next').length;
								console.log(nextCheck);
								
								if(activeCheck === 0){
									$('.fade-slide').first().addClass('active').fadeIn('slow', function(){
										$('.active').next().addClass('next');
									});
								}
								else if(nextCheck === 0){
									$('.active').removeClass('active').fadeOut('slow', function(){
										$('.fade-slide').first().addClass('active').fadeIn('slow', function(){
											$('.active').next().addClass('next');
										});
									});
								}
								else{
									$('.active').removeClass('active').fadeOut('slow', function(){
										$('.next').fadeIn('slow').removeClass('next').addClass('active').next().addClass('next');
									});
								}
								
							}, 5000);
							//End Fading Slideshow
							
							//Begin Team Slideshow
							
							//Slideshow Fadein
							
							setTimeout(function(){
								$('.slideshow').css('opacity', '1');
							}, 500);
							
							//End

							var team_member_width = 0;
							var thisWidth;
							var thisOuter;
							var thisMarginAct;
							
							$('.team-member').each(function(){
								thisWidth = $(this).width();
								thisMargin = $(this).css('marginRight');
								if(thisMargin !== '0px'){
									thisMarginAct = parseInt(thisMargin);
									thisOuter = $(this).outerWidth(true);
									$(this).css('width', thisWidth + 'px').css('marginRight', thisMargin);
									team_member_width = team_member_width + thisOuter;
								}
								else{
									$(this).css('width', thisWidth + 'px').css('marginRight', thisMarginAct + 'px');
									thisOuter = $(this).outerWidth(true);
									team_member_width = team_member_width + thisOuter;
								}
								
							});
							
							var resizeTimer;
							
							var width = $(window).width(), height = $(window).height();

							$(window).on('resize', function(e) {
							
							if($(window).width() != width || $(window).height() != height){
								  width = $(window).width();
								  height = $(window).height();
								  clearTimeout(resizeTimer);
								  resizeTimer = setTimeout(function() {
								  
								    var slideshowWidth = $('.slideshow').width();
									$('.slideshow-inner').css('transition', 'none').css('width', slideshowWidth + 'px');
									
									$('.team-member').each(function(){
										$(this).attr('style', '');
									});
									
									setTimeout(function(){
										$('.team-member').each(function(){
											thisWidth = $(this).width();
											thisMargin = $(this).css('marginRight');
											if(thisMargin !== '0px'){
												thisMarginAct = parseInt(thisMargin);
												thisOuter = $(this).outerWidth(true);
												$(this).css('width', thisWidth + 'px').css('marginRight', thisMargin);
												team_member_width = team_member_width + thisOuter;
											}
											else{
												$(this).css('width', thisWidth + 'px').css('marginRight', thisMarginAct + 'px');
												thisOuter = $(this).outerWidth(true);
												team_member_width = team_member_width + thisOuter;
											}
											
										});
										
										$('.slideshow-inner').css('width',  team_member_width + 'px');
										
										$('.slideshow-inner').css('left', (0 - (thisWidth + thisMarginAct)) + 'px');
				
									}, 1000);
	
								            
								  }, 250);
								}							
							});
							$(window).resize(function(){
								
								
							});
							
							$('.slideshow-inner').css('width',  team_member_width + 'px');
							
							//Setup complete
							
							//Begin Slide setup
							$('.team-member').first().addClass('first').next().addClass('second').next().addClass('next-team');
							
							var lastTeam = $('.team-member').last();
							
							lastTeam.addClass('prev');
							
							$('.first').before(lastTeam);
							
							$('.slideshow-inner').css('left', (0 - (thisWidth + thisMarginAct)) + 'px');
							
							var running = false;
							
							$('.team-member').last().addClass('last');
							
							$('.left-arrow').click(function(){
								if(running === false){
									running = true;
									$('.slideshow-inner').css('left', (0 - ((thisWidth + thisMarginAct) * 2)) + 'px');

									setTimeout(function(){
										$('.last').removeClass('last');
										$('.slideshow-inner').css('transition', 'none').css('left', (0 - (thisWidth + thisMarginAct)) + 'px');
										$('.team-member').last().after($('.prev'));
										$('.prev').removeClass('prev');
										$('.first').first().removeClass('first').addClass('prev');
										$('.second').removeClass('second').addClass('first');
										$('.next-team').removeClass('next-team').addClass('second').next().addClass('next-team');
										$('.team-member').last().addClass('last');
									}, 500);
									
									setTimeout(function(){
										$('.slideshow-inner').css('transition', 'all, 0.5s');	
									}, 550);
									running = false;
								}
							});
							
							$('.right-arrow').click(function(){
								if(running === false){
									running = true;
									
									$('.slideshow-inner').css('transition', '0.5s').css('left', '0px');
									setTimeout(function(){
										$('.team-member').first().before($('.last'));
										$('.next-team').removeClass('next-team');
										$('.second').removeClass('second').addClass('next-team');
										$('.first').removeClass('first').addClass('second');
										$('.prev').removeClass('prev').addClass('first');
										$('.last').removeClass('next-team').removeClass('last').addClass('prev');
										$('.team-member').last().addClass('last');
										$('.slideshow-inner').css('transition', '0s').css('left', (0 - (thisWidth + thisMarginAct)) + 'px');
									}, 500);
									
									setTimeout(function(){
										$('.slideshow-inner').css('transition', 'all, 0.5s');	
									}, 550);
									running = false;
								}
							});
							
							//Sort weird backgrounds.

							
							if(windowWidth <= 1050){
								sectionHeight = $('.background-left').parent().height();
								$('.background-left').parent().css('height', 'auto');	
							}
							else{
								sectionHeight = $('.background-left').parent().height();
								$('.background-left').parent().css('height', sectionHeight + 'px');	
							}
						
							
							//End Team Slideshow
							
							//Mobile Button Stuff
							$('#mobile-button').click(function(){
								if($(this).hasClass('open')){
									$(this).removeClass('open');
									$('nav').slideUp(function(){
										
										if(amountScrolled > 100){
											$('#logo').fadeIn();
										}
										
									});
								}
								else{
									$(this).addClass('open');
									$('#logo').fadeOut(function(){
										$('nav').slideDown();
									});
								}
							});
							
							$(window).resize(function(){
								windowWidth = $(window).width();
								
								if(windowWidth <= 1050){
									sectionHeight = $('.background-left').parent().height();
									$('.background-left').parent().css('height', 'auto');	
								}
								else{
									sectionHeight = $('.background-left').parent().height();
									$('.background-left').parent().css('height', sectionHeight + 'px');	
								}
								
															
							});
							//End Mobile Button Stuff
						}
				},
				//	About	us	page,	note	the	change	from	about-us	to	about_us.
				'about_us':	{
						init:	function()	{
								//	JavaScript	to	be	fired	on	the	about	us	page
						}
				},
				
				'single' : {
					init: function(){
						
					},
					
					finalize: function(){
						$('header a').each(function(){
							var thisHref = $(this).attr('href');
							$(this).attr('href', '/' + thisHref);
						});
						$('#logo').css('top', '0px').addClass('fixed');
						
						$('#logo').click(function(){
							document.location.href="/";
						});
						
						$('#mobile-button').click(function(){
							if($(this).hasClass('open')){
								$(this).removeClass('open');
								$('nav').slideUp(function(){
									$('#logo').fadeIn();
								});
							}
							else{
								$(this).addClass('open');
								$('#logo').fadeOut(function(){
									$('nav').slideDown();
								});
							}
						});
					}
				}
		};

		//	The	routing	fires	all	common	scripts,	followed	by	the	page	specific	scripts.
		//	Add	additional	events	for	more	control	over	timing	e.g.	a	finalize	event
		var	UTIL	=	{
				fire:	function(func,	funcname,	args)	{
						var	fire;
						var	namespace	=	Ctrl;
						funcname	=	(funcname	===	undefined)	?	'init'	:	funcname;
						fire	=	func	!==	'';
						fire	=	fire	&&	namespace[func];
						fire	=	fire	&&	typeof	namespace[func][funcname]	===	'function';

						if	(fire)	{
								namespace[func][funcname](args);
						}
				},
				loadEvents:	function()	{
						//	Fire	common	init	JS
						UTIL.fire('common');

						//	Fire	page-specific	init	JS,	and	then	finalize	JS
						$.each(document.body.className.replace(/-/g,	'_').split(/\s+/),	function(i,	classnm)	{
								UTIL.fire(classnm);
								UTIL.fire(classnm,	'finalize');
						});

						//	Fire	common	finalize	JS
						UTIL.fire('common',	'finalize');
				}
		};

		//	Load	Events
		$(document).ready(UTIL.loadEvents);

})(jQuery);	//	Fully	reference	jQuery	after	this	point.
